<app-accordion>
<app-accordion-item
  id="SkuInventoryHistory"
  icon="clock"
  label="Histórico de Estoque"
  bodyClass="rounded border border-neutral-300 dark:border-neutral-700 p-3"
>
  <!-- ═══ COLLAPSED SUMMARY BAR (when filters are hidden) ═══ -->
  @if (!filtersExpanded && hasSearched) {
  <div class="flex items-center gap-2 flex-wrap animate-slide-in">
    <!-- Active chips -->
    @for (filter of activeFilters; track filter.type) {
      @for (val of filter.values; track val) {
      <span class="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium rounded-lg bg-neutral-100 dark:bg-neutral-800 border-l-[3px] border-l-blue-500">
        <span class="text-neutral-500 dark:text-neutral-400">{{ filter.label }}:</span>
        <span>{{ val }}</span>
        <button type="button" class="ml-0.5 opacity-50 hover:opacity-100 transition-opacity" (click)="removeFilter(filter.type, val)">
          <i [innerHTML]="'x' | feather: { width: 10, height: 10 }"></i>
        </button>
      </span>
      }
    }

    @if (activeFilterCount === 0) {
    <span class="text-xs text-neutral-500 italic">Sem filtros aplicados</span>
    }

    <div class="flex-1"></div>

    <!-- Expand filters button -->
    <button
      type="button"
      class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium border border-neutral-300 dark:border-neutral-600 text-neutral-600 dark:text-neutral-400 hover:border-neutral-400 dark:hover:border-neutral-500 hover:text-neutral-800 dark:hover:text-neutral-200 transition-all cursor-pointer"
      (click)="filtersExpanded = true"
    >
      <i [innerHTML]="'sliders' | feather: { width: 12, height: 12 }"></i>
      Editar filtros
    </button>

    <!-- New search -->
    <app-button color="primary" size="small" (buttonClick)="searchAndCollapse()" icon="search" [disabled]="loading">
      Buscar
    </app-button>
  </div>
  }

  <!-- ═══ EXPANDED FILTERS ═══ -->
  @if (filtersExpanded) {
  <div class="flex flex-col gap-4 animate-fade-in">
    <!-- Row 1: Contas + Ruas -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
      <div>
        <label class="block text-[11px] font-medium mb-1.5 text-neutral-500 dark:text-neutral-400 uppercase tracking-wider">Contas</label>
        <ng-select
          [items]="franchises"
          bindLabel="label"
          bindValue="name"
          [hideSelected]="true"
          [closeOnSelect]="false"
          [clearable]="true"
          [searchable]="true"
          [multiple]="true"
          [(ngModel)]="selectedAccounts"
          placeholder="Selecione as contas"
          [loading]="loadingAccounts"
          [searchFn]="customSearchFn"
          [disabled]="loading"
          class="w-full control-height"
        >
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            {{ item.name?.toUpperCase() }}
            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="flex flex-col">
              <span class="font-medium">{{ item.name }}</span>
              <span class="text-xs text-neutral-500">{{ item.description }}</span>
            </div>
          </ng-template>
        </ng-select>
      </div>

      <div>
        <label class="block text-[11px] font-medium mb-1.5 text-neutral-500 dark:text-neutral-400 uppercase tracking-wider">Ruas</label>
        <ng-select
          [items]="warehouseOptions"
          bindLabel="label"
          bindValue="value"
          [hideSelected]="true"
          [closeOnSelect]="false"
          [clearable]="true"
          [multiple]="true"
          [(ngModel)]="selectedWarehouses"
          placeholder="Selecione as ruas"
          [disabled]="loading"
          class="w-full control-height"
        >
        </ng-select>
      </div>
    </div>

    <!-- Action bar -->
    <div class="flex items-center flex-wrap gap-2 pt-2 border-t border-neutral-200 dark:border-neutral-700/50">
      @if (activeFilterCount > 0) {
      <button
        type="button"
        class="inline-flex items-center gap-1 text-xs text-neutral-500 hover:text-neutral-700 dark:hover:text-neutral-200 transition-colors cursor-pointer"
        (click)="clearAllFilters()"
      >
        <i [innerHTML]="'rotate-ccw' | feather: { width: 12, height: 12 }"></i>
        Limpar filtros
      </button>
      }

      <div class="flex items-center gap-2 ml-auto">
        <!-- De popover -->
        <div class="relative" (click)="$event.stopPropagation()">
          <button type="button"
            class="inline-flex items-center gap-1.5 h-8 px-3 text-xs border rounded-lg transition-all cursor-pointer"
            [ngClass]="showFromPopover
              ? 'border-blue-500 bg-blue-50 dark:bg-blue-950 text-blue-700 dark:text-blue-300'
              : 'border-neutral-300 dark:border-neutral-600 bg-white dark:bg-neutral-800 text-black dark:text-white hover:border-neutral-400'"
            (click)="toggleFromPopover($event)"
            [disabled]="loading"
          >
            <span class="text-[11px] font-medium text-neutral-500 uppercase tracking-wider">De</span>
            <span class="font-medium">{{ fromDisplayValue }}</span>
            <i [innerHTML]="(showFromPopover ? 'chevron-up' : 'chevron-down') | feather: { width: 12, height: 12 }"></i>
          </button>
          @if (showFromPopover) {
          <div class="absolute top-full left-0 mt-1 z-50 w-64 p-3 rounded-lg border border-neutral-300 dark:border-neutral-600 bg-white dark:bg-neutral-800 shadow-lg animate-fade-in">
            <div class="flex flex-wrap gap-1.5 mb-3">
              @for (p of [
                { key: 'today', label: 'Hoje' },
                { key: '7d', label: '7 dias' },
                { key: '30d', label: '30 dias' },
                { key: 'month', label: 'Este mês' }
              ]; track p.key) {
              <button type="button"
                class="px-2.5 py-1 rounded-full text-xs font-medium border transition-all"
                [ngClass]="activePreset === p.key
                  ? 'bg-blue-500 border-blue-500 text-white'
                  : 'border-neutral-300 dark:border-neutral-600 text-neutral-600 dark:text-neutral-400 hover:border-neutral-400'"
                (click)="applyFromPreset($any(p.key))"
              >{{ p.label }}</button>
              }
            </div>
            <div class="flex gap-2">
              <div class="flex-1">
                <label class="block text-[10px] font-medium text-neutral-500 uppercase mb-1">Data</label>
                <input type="date"
                  class="w-full h-8 px-2 text-xs border rounded-md bg-white dark:bg-neutral-900 text-black dark:text-white border-neutral-300 dark:border-neutral-600 focus:border-blue-500 focus:outline-none"
                  [ngModel]="dateFrom"
                  (ngModelChange)="dateFrom = $event; datetimeFrom = dateFrom + 'T' + (timeFrom || '00:00'); onDatetimeFromChange(); activePreset = null" />
              </div>
              <div class="w-20">
                <label class="block text-[10px] font-medium text-neutral-500 uppercase mb-1">Hora</label>
                <input type="time"
                  class="w-full h-8 px-2 text-xs border rounded-md bg-white dark:bg-neutral-900 text-black dark:text-white border-neutral-300 dark:border-neutral-600 focus:border-blue-500 focus:outline-none"
                  [ngModel]="timeFrom"
                  (ngModelChange)="timeFrom = $event; datetimeFrom = dateFrom + 'T' + timeFrom; onDatetimeFromChange(); activePreset = null" />
              </div>
            </div>
          </div>
          }
        </div>

        <!-- Até popover -->
        <div class="relative" (click)="$event.stopPropagation()">
          <button type="button"
            class="inline-flex items-center gap-1.5 h-8 px-3 text-xs border rounded-lg transition-all cursor-pointer"
            [ngClass]="showToPopover
              ? 'border-blue-500 bg-blue-50 dark:bg-blue-950 text-blue-700 dark:text-blue-300'
              : 'border-neutral-300 dark:border-neutral-600 bg-white dark:bg-neutral-800 text-black dark:text-white hover:border-neutral-400'"
            (click)="toggleToPopover($event)"
            [disabled]="loading"
          >
            <span class="text-[11px] font-medium text-neutral-500 uppercase tracking-wider">Até</span>
            <span class="font-medium">{{ toDisplayValue }}</span>
            <i [innerHTML]="(showToPopover ? 'chevron-up' : 'chevron-down') | feather: { width: 12, height: 12 }"></i>
          </button>
          @if (showToPopover) {
          <div class="absolute top-full right-0 mt-1 z-50 w-64 p-3 rounded-lg border border-neutral-300 dark:border-neutral-600 bg-white dark:bg-neutral-800 shadow-lg animate-fade-in">
            <div class="flex gap-2">
              <div class="flex-1">
                <label class="block text-[10px] font-medium text-neutral-500 uppercase mb-1">Data</label>
                <input type="date"
                  class="w-full h-8 px-2 text-xs border rounded-md bg-white dark:bg-neutral-900 text-black dark:text-white border-neutral-300 dark:border-neutral-600 focus:border-blue-500 focus:outline-none"
                  [ngModel]="dateTo"
                  (ngModelChange)="dateTo = $event; datetimeTo = dateTo + 'T' + (timeTo || '23:59'); onDatetimeToChange()" />
              </div>
              <div class="w-20">
                <label class="block text-[10px] font-medium text-neutral-500 uppercase mb-1">Hora</label>
                <input type="time"
                  class="w-full h-8 px-2 text-xs border rounded-md bg-white dark:bg-neutral-900 text-black dark:text-white border-neutral-300 dark:border-neutral-600 focus:border-blue-500 focus:outline-none"
                  [ngModel]="timeTo"
                  (ngModelChange)="timeTo = $event; datetimeTo = dateTo + 'T' + timeTo; onDatetimeToChange()" />
              </div>
            </div>
          </div>
          }
        </div>

        <app-button color="primary" size="small" (buttonClick)="searchAndCollapse()" icon="search" [disabled]="loading">
          Buscar
        </app-button>
      </div>
    </div>
  </div>
  }

  <!-- ═══ RESULTS ═══ -->
  @if (loading) {
  <div class="my-3 flex flex-col items-center gap-2">
    <app-loading />
    <span class="text-sm text-neutral-500">
      Processando consulta... (tentativa {{ pollingAttempt }} de 5)
    </span>
  </div>
  }
  @if (!!error) {
  <app-alert [type]="'danger'" class="mt-3">{{ error }}</app-alert>
  }
  @if (hasSearched && !loading) {
  <div class="mt-4 min-h-[200px]">
    @if (allData.length === 0) {
    <p class="text-center text-neutral-500 py-3">Nenhum resultado encontrado.</p>
    } @else {
    <div class="overflow-x-auto">
    <table class="table-fixed w-full border-collapse border border-slate-400 min-w-[600px]">
      <thead class="bg-neutral-100 dark:bg-neutral-700">
        <tr>
          <th class="w-[18%] p-3 text-left text-sm">Data</th>
          <th class="w-[12%] p-3 text-left text-sm">Hora</th>
          <th class="w-[30%] p-3 text-left text-sm">Conta</th>
          <th class="w-[20%] p-3 text-left text-sm">Estoque</th>
          <th class="w-[20%] p-3 text-right text-sm">Quantidade</th>
        </tr>
      </thead>
      <tbody>
        @for (item of data; track $index; let even = $even) {
        <tr [ngClass]="even ? 'bg-neutral-50 dark:bg-neutral-800' : 'bg-white dark:bg-neutral-900'">
          <td class="p-3 text-sm">{{ item.date | date: 'dd/MM/yyyy' }}</td>
          <td class="p-3 text-sm">{{ item.time }}</td>
          <td class="p-3 text-sm">{{ item.account }}</td>
          <td class="p-3 text-sm">Rua {{ item.warehouseName.slice(-1).toUpperCase() }}</td>
          <td class="p-3 text-sm text-right font-medium" [ngClass]="item.quantity <= 0 ? 'text-red-500' : 'text-green-500'">{{ item.quantity }}</td>
        </tr>
        }
        @for (_ of emptyRows; track $index) {
        <tr [ngClass]="(data.length + $index) % 2 === 0 ? 'bg-neutral-50 dark:bg-neutral-800' : 'bg-white dark:bg-neutral-900'">
          <td class="p-3 text-sm">&nbsp;</td>
          <td class="p-3 text-sm">&nbsp;</td>
          <td class="p-3 text-sm">&nbsp;</td>
          <td class="p-3 text-sm">&nbsp;</td>
          <td class="p-3 text-sm">&nbsp;</td>
        </tr>
        }
      </tbody>
    </table>
    </div>
    @if (allData.length > 10) {
    <div class="mt-3">
      <div class="flex items-center justify-center gap-3">
        <app-button
          size="small"
          color="primary"
          (buttonClick)="onPaginationChange(paginationState().currentPage - 1)"
          [disabled]="paginationState().currentPage === 0"
        >Anterior</app-button>
        <span class="text-sm text-neutral-500 inline-block w-16 text-center tabular-nums">{{ paginationState().currentPage + 1 }} / {{ totalPages }}</span>
        <app-button
          size="small"
          color="primary"
          (buttonClick)="onPaginationChange(paginationState().currentPage + 1)"
          [disabled]="(paginationState().currentPage + 1) * paginationState().itemsPerPage >= paginationState().totalItems"
        >Próximo</app-button>
      </div>
    </div>
    }
    }
  </div>
  }
</app-accordion-item>
</app-accordion>
